export class SetCustomFilterGroup {
  constructor(public payload: { id: string; enabled: boolean }) {}
}
